import React from "react";

const SvgCloseBlack = props => <svg viewBox="0 0 20 20" {...props}><path fill="#0B0D0E" fillRule="evenodd" d="M11.414 10l6.293-6.293a1 1 0 0 0-1.414-1.414L10 8.586 3.707 2.293a1 1 0 0 0-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 0 0 1.414 1.414L10 11.414l6.293 6.293a.996.996 0 0 0 1.414 0 1 1 0 0 0 0-1.414L11.414 10z" /></svg>;

export default SvgCloseBlack;